import React from 'react';
import { Box, CircularProgress, Pagination, Paper, Typography } from '@mui/material';

import type { ProviderRuleResponse } from '../types';

import { RuleTableHeader, RuleTableRow } from './RuleTableRow';

interface RulesListProps {
  rules: ProviderRuleResponse[];
  isLoading: boolean;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onRuleClick: (rule: ProviderRuleResponse) => void;
}

export const RulesList: React.FC<RulesListProps> = ({
  rules,
  isLoading,
  page,
  totalPages,
  onPageChange,
  onRuleClick,
}) => {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!rules.length) {
    return (
      <Box
        sx={{
          textAlign: 'center',
          py: 8,
          bgcolor: 'background.paper',
          borderRadius: 2,
          border: '1px dashed',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" color="text.secondary">
          No rules found
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Try adjusting your filters or search query
        </Typography>
      </Box>
    );
  }

  return (
    <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'grey.200', borderRadius: 3, overflow: 'hidden' }}>
      <RuleTableHeader />
      <Box>
        {rules.map(item => (
          <RuleTableRow
            key={`${item.rule_id}-${item.rule_type}`}
            ruleResponse={item}
            onClick={() => onRuleClick(item)}
          />
        ))}
      </Box>

      {totalPages > 1 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            py: 3,
            borderTop: '1px solid',
            borderColor: 'grey.100',
          }}
        >
          <Pagination
            count={totalPages}
            page={page}
            onChange={(_, p) => onPageChange(p)}
            color="primary"
            size="small"
          />
        </Box>
      )}
    </Paper>
  );
};

